import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.farm.widget.admin.farm.tab');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'wiz-portal-farm-widget-admin-farm-tab',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.farm.widget.admin.farm.tab/view.scss */
/* src/app/portal.farm.widget.admin.farm.tab/view.scss: no such file or directory */`],
})
export class PortalFarmWidgetAdminFarmTabComponent implements OnInit, OnDestroy {

    @Input() farm_id!: string;
    @Input() farm!: { farm_name: string };
    @Input() basePath: string = '/admin/farm';
    @Input() listPath: string = '/admin/farm/list';
    @Input() showList: boolean = true;

    public type = 'list';
    public role: string | null = null;

    private routerSub: Subscription;

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) {}

    public async ngOnInit() {
        await this.service.init();

        await this.service.auth.allow();

        this.role = this.service.auth.session?.role || null;

        this.syncType();

        this.routerSub = this.router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe(() => {
                this.syncType();
                this.service.render();
            });

        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private syncType() {
        this.type = WizRoute.segment.type || 'list';
    }

    public async go(type: string) {
        if (type === 'list') {
            await this.router.navigateByUrl(this.listPath);
        } else {
            await this.router.navigateByUrl(`${this.basePath}/${type}/${this.farm_id}`);
        }
    }
}

export default PortalFarmWidgetAdminFarmTabComponent;